import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "PageView",
      component: (resolve) => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home",
        },
        {
          path: "/home",
          name: "home",
          component: (resolve) => require(["@/view/HomePage"], resolve),
          meta: {
            title: "凤凰植保会",
          },
        },
        {
          path: "/plan",
          name: "plan",
          component: (resolve) => require(["@/view/Plan"], resolve),
          meta: {
            title: "凤凰植保会计划",
          },
          children: [
            {
              path: "/plan",
              redirect: "/plan/anhui",
            },
            {
              path: "/plan/anhui",
              name: "anhui",
              component: (resolve) => require(["@/view/PlanAnHui"], resolve),
              meta: {
                title: "安徽植保会",
              },
            },
            {
              path: "/plan/shanxi",
              name: "shanxi",
              component: (resolve) => require(["@/view/PlanShanxi"], resolve),
              meta: {
                title: "西北植保会",
              },
            },
            {
              path: "/plan/xibu",
              name: "xibu",
              component: (resolve) => require(["@/view/PlanXiBu"], resolve),
              meta: {
                title: "西部植保会",
              },
            },
            {
              path: "/plan/shandong",
              name: "shandong",
              component: (resolve) => require(["@/view/PlanShanDong"], resolve),
              meta: {
                title: "山东植保会",
              },
            },
            {
              path: "/plan/wholecountry",
              name: "wholecountry",
              component: (resolve) =>
                require(["@/view/PlanWholeCountry"], resolve),
              meta: {
                title: "全国植保会",
              },
            },
            {
              path: "/plan/heilongjiang",
              name: "heilongjiang",
              component: (resolve) =>
                require(["@/view/PlanHeiLongJiang"], resolve),
              meta: {
                title: "黑龙江植保会",
              },
            },
            {
              path: "/plan/search",
              name: "search",
              component: (resolve) => require(["@/view/Search"], resolve),
              meta: {
                title: "搜索",
              },
            },
          ],
        },
        {
          path: "/exhibition",
          name: "exhibition",
          component: (resolve) => require(["@/view/Exhibition"], resolve),
          meta: {
            title: "参展植保会",
          },
          children: [
            {
              path: "/exhibition",
              redirect: "/exhibition/sys",
            },
            {
              path: "/exhibition/sys",
              name: "sys",
              component: (resolve) =>
                require(["@/view/ExhibitionSys"], resolve),
              meta: {
                title: "展商系统",
              },
            },
            {
              path: "/exhibition/invite",
              name: "invite",
              component: (resolve) =>
                require(["@/view/ExhibitionInvite"], resolve),
              meta: {
                title: "联合邀约",
              },
            },
            {
              path: "/exhibition/download",
              name: "download",
              component: (resolve) =>
                require(["@/view/ExhibitionDownload"], resolve),
              meta: {
                title: "资料下载",
              },
            },
            {
              path: "/exhibition/downloaddetail",
              name: "download",
              component: (resolve) =>
                require(["@/view/DownloadDetail"], resolve),
              meta: {
                title: "下载详情",
              },
            },
          ],
        },
        {
          path: "/visit",
          name: "visit",
          component: (resolve) => require(["@/view/Visit"], resolve),
          meta: {
            title: "参观植保会",
          },
          children: [
            {
              path: "/visit",
              redirect: "/visit/register",
            },
            {
              path: "/visit/register",
              name: "register",
              component: (resolve) =>
                require(["@/view/VisitRegister"], resolve),
              meta: {
                title: "观众预登记",
              },
            },
            {
              path: "/visit/guide",
              name: "guide",
              component: (resolve) => require(["@/view/VisitGuide"], resolve),
              meta: {
                title: "参观指南",
              },
            },
          ],
        },
        {
          path: "/dynamic",
          name: "dynamic",
          component: (resolve) => require(["@/view/Dynamic"], resolve),
          meta: {
            title: "植保会动态",
          },
          children: [
            {
              path: "/dynamic",
              redirect: "/dynamic/exhibition",
            },
            {
              path: "/dynamic/exhibition",
              name: "exhibition",
              component: (resolve) =>
                require(["@/view/DynamicExhibition"], resolve),
              meta: {
                title: "展会动态",
              },
            },
            {
              path: "/dynamic/information",
              name: "information",
              component: (resolve) =>
                require(["@/view/DynamicInformation"], resolve),
              meta: {
                title: "行业动态",
              },
            },
            {
              path: "/dynamic/previousreview",
              name: "previousreview",
              component: (resolve) =>
                require(["@/view/DynamicPreviousReview"], resolve),
              meta: {
                title: "往届回顾",
              },
            },
            {
              path: "/dynamic/media",
              name: "media",
              component: (resolve) => require(["@/view/DynamicMedia"], resolve),
              meta: {
                title: "合作媒体",
              },
            },
            {
              path: "/dynamic/video",
              name: "video",
              component: (resolve) => require(["@/view/DynamicVideo"], resolve),
              meta: {
                title: "视频",
              },
            },
            {
              path: "/dynamic/videoDetail",
              name: "videoDetail",
              component: (resolve) => require(["@/view/VideoDetail"], resolve),
              meta: {
                title: "视频详情",
              },
            },
            {
              path: "/dynamic/dynamicdetail",
              name: "dynamicdetail",
              component: (resolve) =>
                require(["@/view/dynamicDetail"], resolve),
              meta: {
                title: "展会动态详情",
              },
            },
          ],
        },
        {
          path: "/contactus",
          name: "contactus",
          component: (resolve) => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们",
          },
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js